import { requestError } from "utils/requestHandler"

export const ErrorHandler = (error) => {
  requestError( error.error || error.msg || error )
}